import { Component, Vue } from "vue-property-decorator";

/**
 * Abstract basic user management functionality
 */
@Component
class UserManagementBtnMixin extends Vue {
  /**
   * indicate if model is shown
   */
  public modalShow = false;

  /**
   * indicate if create user request pending
   */
  public isLoading = false;
}
export default UserManagementBtnMixin;
